import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";

var SvgFontColor = function SvgFontColor(props) {
  return _jsx("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    role: "img"
  }, props), {}, {
    children: _jsx("path", {
      fill: props.color || '#909090',
      d: "M13.558 12.901A.8.8 0 0 1 12.816 14h-.585a.821.821 0 0 1-.493-.141.868.868 0 0 1-.272-.365l-.919-2.448H5.453l-.919 2.448a.779.779 0 0 1-.272.348.748.748 0 0 1-.485.158h-.593a.8.8 0 0 1-.742-1.099L6.553 2.69A1.1 1.1 0 0 1 7.573 2h.853a1.1 1.1 0 0 1 1.02.69l4.113 10.21ZM6.066 8.943h3.92L8.463 5.477a28.534 28.534 0 0 1-.23-.622 20.15 20.15 0 0 1-.237-.789c-.08.283-.159.545-.238.789a7.632 7.632 0 0 1-.221.639L6.066 8.943Z"
    })
  }));
};

export default SvgFontColor;